import { gql } from '@apollo/client'

export const BATIMENTS_QUERY = gql`
  query Batiments($coproprieteid: bigint!) {
    batiments: d4_batiment(where: { copropriete_id: { _eq: $coproprieteid } }) {
      libelle
      id
    }
  }
`
